(function () {
  function init() {
    setTimeout(function () {
      var kit = window.UploadKit;
      if (!kit || typeof kit.resetUploaders !== 'function') return;

      var uploaders = kit.config && kit.config.uploaders;
      if (!Array.isArray(uploaders) || !uploaders[2] || typeof uploaders[2] !== 'object') return;

      try {
        uploaders[2].required = false;
        kit.resetUploaders();
      } catch (e) {
        console.warn('UploadKit reset failed:', e);
      }
    }, 500);

    document.addEventListener('click', function (event) {
      if (!event.target.closest("div[data-block-type='variant-picker'] .block-swatch")) return;

      setTimeout(function () {
        const urlParams = new URLSearchParams(window.location.search);
        const variant_id = urlParams.get('variant');

        setVariantId('.v-stack .price-list.price-list--product .custom-sale-price-price.h4.text-subdued', variant_id);
        setVariantId('.v-stack .price-list .custom-sale-price-.h6.text-subdued', variant_id);

        setVariantId('.v-stack .price-list.price-list--product .custom-compare-price-price', variant_id);
        setVariantId('.v-stack .price-list .custom-compare-price-', variant_id);
      }, 50);
    });

    if (document.querySelectorAll("buy-buttons[template='custom-order-help-choose']").length > 0) {
      document.querySelectorAll(".product-sticky-bar button[type='submit']").forEach(function (button) {
        button.addEventListener('click', function (e) {
          e.preventDefault();
          document.querySelectorAll("[data-block-type='@app'] + [data-block-type='buy-buttons'] .buy-buttons > button[type='submit']").forEach(function (el) {
            el.click();
          });
        });
      });
    }
  }

  // Equivalent of jQuery(selector).attr("data-variant-id", value)
  function setVariantId(selector, value) {
    document.querySelectorAll(selector).forEach(function (el) {
      if (value === null) {
        el.removeAttribute('data-variant-id');
      } else {
        el.setAttribute('data-variant-id', value);
      }
    });
  }

  // Equivalent of jQuery(document).ready()
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();